<template>
<div class="page_shopdetail page_iteminfo kuaizhao">
	<van-notice-bar  left-icon="volume-o"  text="当前页面内容为订单快照，买卖双方和平台再发生交易争议时，该页面作为判定依据。"/>
    <div class="goods_logo">
        <van-swipe class="my-swipe detail_swipe" :autoplay="bannerTime">
            <van-swipe-item :show-indicators="false" :loop="false" v-for="(item,index) in goodsDetail.good_album" :key="index">
                <img :src="imageUrl+item" alt="" />
            </van-swipe-item>
        </van-swipe>
        <!-- <img :src="this.publicPath + 'statics/images/temp/good.png'" alt="" /> -->
    </div>
    <div class="goods_top">
        <div class="title">
            <span>{{ goodsDetail.good_title }}</span>
            <span class="icon_self" v-if="goodsDetail.is_self">自营</span>
        </div>
        <div class="goods_info">
			<span class="">已选：{{ goodsDetail.good_spec_name ? goodsDetail.good_spec_name :  goodsDetail.good_title}}，数量：{{ goodsDetail.nums }}</span>
            <div class="">单价：￥{{ goodsDetail.prices }}，总计：{{ goodsDetail.total_prices }}</div>
        </div>
    </div>
    <!-- 作品详情 -->
    <div class="xiangqing">
        <div class="nr">
            <div class="title">作品详情</div>
            <!-- 属性 -->
            <div class="table">
                <div class="tr clearfix" v-for="(guige,index) in goodsDetail.good_attrs" :key="index">
                    <div class="" v-if="guige.good_attr_value">
						<div class="f-l">{{ guige.good_attr_name }}</div>
                    	<div class="f-r">{{ guige.good_attr_value }}</div>
					</div>
                </div>
            </div>
            <!-- 内容介绍 -->
            <p v-html="goodsDetail.content" class="jieshao"></p>
        </div>
    </div>
</div>
</template>

<script>
import router from "../../../../../.././router";
import {
    LOGOUT,
    LOGIN,
    SETTLE
} from "../../../../../.././vuex/mutation_types";
import Vue from "vue";
import Bridge from "../../../../../.././vuex/bridge.js";
import { Toast } from 'vant';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    // name: "map-index",
    data() {
        return {
			richImageUrl: this.$publicData.richTextImage,
			imageUrl: this.$publicData.uploadImage,
            bannerTime: '3000',
			orderId: this.$route.query.orderId,
            goodsId: this.$route.query.goodsId,
            publicPath: process.env.BASE_URL,
            show_sku: false, // 规格弹层
            tag_buy: false, // 购买标识
            tag_addCart: false, // 加购标识
            goodsDetail: {},
            goodsSpec: [],
            goods: {
                picture: "https://img.yzcdn.cn/1.jpg", // 默认商品 sku 缩略图
            },
            selectSpec: "",
            selectPrice: {},
            selectNum: 1,
            token: null,
            goodcomment: {}, // 评论
			shareConfig: null, // 分享的相关配置
			show_poster: false, // 海报弹层
			posterUrl: null, // 分享图链接
            showSkuImage: false, // 规格图片
        };
    },
    components: {
        // PageSearch
    },
    created: function () {
        // this.$store.commit(LOGIN, {
        //     token: 'PcXDUJmXARBSUuN9KBl74Q==',
        // });
        // 根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    naviBlackStyle: true,
                    naviTitle: "订单快照",
                    levitate: true
                },
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    }
					this.getGoodsDetailData();
					
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback("");
                }
            );
        } else {
            this.token = this.$store.getters.token;
			this.getGoodsDetailData();
        }
    },
    methods: {
        // 获取商品详情
        getGoodsDetailData() {
			var that = this;
            var params = {
                token: this.token,
				order_id: this.orderId,
                good_id: this.goodsId,
            };
            this.$api.shop.orderphoto(params).then((res) => {
                if (res.code == 200) {
					// 如果该商品不存在
					if(res.result.isset == 0){
						this.$toast('该商品不存在');
						setTimeout(function(){
							this.$router.push("/");
						},200)
					};
					// 如果该商品存在
					// 处理富文本
					let info = res.result;
					info.content = info.content.replace(/(<img [^>]*src=['"])([^'"]+)([^>]*)/g,function(match,$1,$2,$3){
						if(/^http/.test($2)){
							return $1 + $2 + $3;
						}else{
							return $1 + that.richImageUrl +$2 + $3;
						}
					});
                    this.goodsDetail = info;
                } else {
                    this.$toast(res.message);
                }
            });
        },
        toTradesman(type) {
            if (type == null || type == undefined || type == '') {
                type = 'a'
            }
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + this.goodsDetail.tradesman.id + '&type=' + type
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: this.goodsDetail.tradesman.id,
                        type: type
                    }
                })
            }
        },
        // 供应商 店铺
        toSeller() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/seller/detail?sellerId=' + this.goodsDetail.tradesman.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/seller/detail',
                    query: {
                        sellerId: this.goodsDetail.tradesman.id
                    }
                })
            }
        },
        // 字符转码
        unicode2Ch(str) {
            if (!str) {
                return;
            }
            // 控制循环跃迁
            var len = 1;
            var result = "";
            // 注意，这里循环变量的变化是i=i+len 了
            for (var i = 0; i < str.length; i = i + len) {
                len = 1;
                var temp = str.charAt(i);
                if (temp == "\\") {
                    // 找到形如 \u 的字符序列
                    if (str.charAt(i + 1) == "u") {
                        // 提取从i+2开始(包括)的 四个字符
                        var unicode = str.substr(i + 2, 4);
                        // 以16进制为基数解析unicode字符串，得到一个10进制的数字
                        result += String.fromCharCode(parseInt(unicode, 16).toString(10));
                        // 提取这个unicode经过了5个字符， 去掉这5次循环
                        len = 6;
                    } else {
                        result += temp;
                    }
                } else {
                    result += temp;
                }
            }
            return result;
        }
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.detail_wrap .project_info {
    text-align: left;
    padding: 0.4rem 0;
}

.page_shopdetail .jieshao {
    padding-left: 0;
    padding-right: 0;
}
/deep/.jieshao section{
	display: block !important;
}
</style>
